import React, { useEffect, useState } from "react";
import "../styles/ContentSection.css"; // Adjust the path as necessary

const ContentSection = ({ content, language }) => {
  const [lang, setLang] = useState(language || "en");

  useEffect(() => {
    setLang(language);
  }, [language]);

  const currentContent = content[lang];

  // Check if currentContent is defined
  if (!currentContent) {
    return (
      <section className={`content-section ${lang === "ar" ? "rtl" : ""}`}>
        <div className="horizontal-line"></div>
        <h2 className="content-title">Content Not Available</h2>
        <div className="horizontal-line"></div>
      </section>
    );
  }

  const { title, paragraph1, paragraph2, paragraph3 } = currentContent;

  return (
    <section className={`content-section ${lang === "ar" ? "rtl" : ""}`}>
      <div className="horizontal-line"></div>
      <h2 className="content-title">{title}</h2>
      {paragraph1 && <p className="content-paragraph">{paragraph1}</p>}
      {paragraph2 && <p className="content-paragraph">{paragraph2}</p>}
      {paragraph3 && <p className="content-paragraph">{paragraph3}</p>}
      <div className="horizontal-line"></div>
    </section>
  );
};

export default ContentSection;
